import React from 'react';
import DeliverabilityHub from '@/components/ui/DeliverabilityHub/DeliverabilityHub';

export default function DeliverabilityHubPage() {
  return <DeliverabilityHub />;
}
